import Vue from "vue";
import MongoService from "@/services/MongoService";

export default Vue.extend({
  computed: {
    $mongoService(): MongoService {
      return new MongoService(this.$userToken);
    },
  },
});
